module.exports = __webpack_public_path__ + "static/media/dv_app_logo.9fe5117d.png";